var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookSolidinline = function SvgFacebookSolidinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0C0F",
    d: "M6.251 15.556v-6.69H4V6.257h2.251V4.335C6.251 2.104 7.614.89 9.605.89c.953 0 1.773.07 2.012.103v2.331l-1.381.001c-1.083 0-1.292.515-1.292 1.27v1.664h2.582l-.336 2.607H8.944v6.69z"
  })));
};
export default SvgFacebookSolidinline;